import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { Translate, openFile, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './language.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

export const LanguageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const languageEntity = useAppSelector(state => state.language.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="languageDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.language.detail.title">Language</Translate>
        </h2>
        {languageEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {languageEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.language.code" />
          </FieldLabel>
          <FieldValue>{languageEntity.code}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.language.title" />
          </FieldLabel>
          <FieldValue>{languageEntity.title}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.language.icon" />
          </FieldLabel>
          <FieldValue>{languageEntity.icon}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.language.defaultImage" />
          </FieldLabel>
          <FieldValue>{languageEntity.defaultImage}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.language.defaultImageData" />
          </FieldLabel>
          {languageEntity.defaultImageData ? (
            <Box sx={{ mb: 2 }}>
              {languageEntity.defaultImageDataContentType ? (
                <a onClick={openFile(languageEntity.defaultImageDataContentType, languageEntity.defaultImageData)}>
                  <img
                    src={`data:${languageEntity.defaultImageDataContentType};base64,${languageEntity.defaultImageData}`}
                    style={{ maxHeight: '30px' }}
                  />
                </a>
              ) : null}
              <Typography variant="body2" color="text.secondary">
                {languageEntity.defaultImageDataContentType}, {byteSize(languageEntity.defaultImageData)}
              </Typography>
            </Box>
          ) : (
            <FieldValue>No image</FieldValue>
          )}

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.language.createdDate" />
          </FieldLabel>
          <FieldValue>
            {languageEntity.createdDate ? (
              <TextFormat value={languageEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </FieldValue>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.language.createdBy" />
          </FieldLabel>
          <FieldValue>{languageEntity.createdBy ? languageEntity.createdBy.login : ''}</FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              component={Link}
              to="/language"
              replace
              color="info"
              variant="outlined"
              startIcon={<FontAwesomeIcon icon="arrow-left" />}
            >
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/language/${languageEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LanguageDetail;
